export const StorageKeys = {
  CONFIG: 'config',
  RESOURCES: 'resources',
  DATA: 'data',
  USER: 'user',
  EMPLEADO: 'empleado',
  LIST_REPARTOS: 'listRepartos',
  DIRECCIONES: 'direcciones'
} as const;
export type StorageKey = (typeof StorageKeys)[keyof typeof StorageKeys];
